var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenvionLogoSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 797,
    height: 582,
    viewBox: "0 0 797 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.483 295.406L630.33 239.161L797 195.534C794.294 172.848 784.554 154.86 773.19 136.604C704.195 26.2621 564.041 3.30775 439.174 0.623025C317.149 -1.92746 174.695 -0.450865 81.7548 82.2386C23.5828 133.92 -4.69148 210.031 0.719874 287.888C-5.23261 369.101 25.8826 448.435 88.3837 499.579C155.89 554.884 271.693 582 356.651 582H495.453C574.052 582 675.245 559.851 736.258 507.767C769.537 479.309 800.653 412.594 795.377 364.537L596.915 365.88C593.669 393.398 571.617 409.104 545.102 413.265C471.372 424.809 354.487 425.078 286.304 397.962C213.521 369.101 196.611 296.48 225.156 224.395C236.249 196.339 257.083 174.862 286.574 165.062C318.772 151.236 353.134 144.524 388.578 144.122L547.943 142.779L393.854 248.155L400.754 295.137L400.483 295.406Z",
    fill: "#FFA700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenvionLogoSolid);
export default __webpack_public_path__ + "static/media/renvion-logo-solid.79e465227598361b6cf834bcae53edf4.svg";
export { ForwardRef as ReactComponent };